import { InfoDetailsProps } from 'components/info-component/info-component';
import { TableColumnProps } from 'components/table/table-component/table-component';

export const OpenSourceTableStructure: TableColumnProps[] = [
  {
    id: 'package',
    title: 'Package Name',
    withSort: true,
    withSearch: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'last_release',
    title: 'Last Release',
    withSort: true,
    isDate: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'license',
    title: 'License',
    withSort: true,
    withSearch: true,
    position: 'left',
  },
  {
    id: 'advisory_count',
    title: 'Security Advisory',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'total_score',
    title: 'Health Rating',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'package_manager',
    title: 'Package Manager',
    withSort: true,
    position: 'left',
  },
  {
    id: 'repositories',
    title: 'Repositories',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
];

export const OpenSourceTableStructureWithoutHealthRating: TableColumnProps[] = [
  {
    id: 'package',
    title: 'Package Name',
    withSort: true,
    withSearch: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'last_release',
    title: 'Last Release',
    withSort: true,
    isDate: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'license',
    title: 'License',
    withSort: true,
    withSearch: true,
    position: 'left',
  },
  {
    id: 'advisory_count',
    title: 'Security Advisory',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'package_manager',
    title: 'Package Manager',
    withSort: true,
    position: 'left',
  },
  {
    id: 'repositories',
    title: 'Repositories',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
];

export const openSourceInfoStructure: InfoDetailsProps[] = [
  {
    id: 'oss_name',
    title: 'Open Source',
  },
  {
    id: 'last_release',
    title: 'Last Release',
    // isDate: true,
  },
  {
    id: 'license',
    title: 'License',
  },
  {
    id: 'package_manager',
    title: 'Package Manager',
  },
  {
    id: 'advisories',
    title: 'Security Advisories',
  },
];
